import "./PRmanager.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Modal, Button, Table } from "react-bootstrap";
import { useState, useEffect, useRef, useMemo } from "react";
import Instance from "../../Utils/Axios";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../Utils/index";
import axios from "axios";
import useKeyScroll from "../../Hooks/useKeyScroll";
import Select from "react-select";
import Stepper from "../StepperComp/stepper";
import useFormValidation from "../../Hooks/useformValidation";
import { submitPrSchema } from "../../Utils/validationSchema";
import ReactQuill from "react-quill";
import PropTypes from "prop-types";
import {
  normalizeHtmlValue,
  getEditorMetrics,
  quillFormats,
  getQuillModules,
  PRContentPreview,
} from "./quillConfig";
import { prepareDescriptionPayload, fixEncodingCorruption } from "../../Utils/encodingUtils";



export default function PRpreview({ onShowPRLayout }) {
  const scrollContainerRef = useKeyScroll();
  const [editorData, setEditorData] = useState("");
  const [navshow, setnavshow] = useState(0);
  const [companyId, setCompanyId] = useState("");
  const [company, setCompany] = useState({
    name: "",
    contactPerson: "",
    address: "",
    mobile: "",
    email: "",
    website: "",
    state: "",
    country: "",
    city: "",
  });
  const [formData, setFormData] = useState({
    // tokenId: "",
    packageId: "",
    packageMemberId: "",
    title: "",
    description: "",
    showContactDetails: "YES",
    image: "",
    addNote: "",
    status: "",
    categoryId: "",
  });
  const [error, setError] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [imagesList, setImagesList] = useState([]);
  const [imageInfo, setImageInfo] = useState([]);
  const [fileName, setFileName] = useState("");
  const [selectedFilePath, setSelectedFilePath] = useState("");
  const navigate = useNavigate();
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedImagesData, setSelectedImagesData] = useState([]);
  const fileInputRef = useRef(null);
  const isReadOnly = navshow === 1;
  const [limitErrors, setLimitErrors] = useState({});
  const [showSubmit, setShowSubmit] = useState(false);
  const [editorHeight, setEditorHeight] = useState(null);

  const WORD_LIMIT = 1500;
  const IMG_LIMIT = 5;
  const LINK_LIMIT = 5;

  const MAX_FILE_SIZE_MB = 10;
  const MAX_FILE_COUNT = 3;
  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/bmp",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/csv",
    "application/vnd.ms-excel"
  ];

  const steps = [
    { label: "Edit PR" },
    { label: "Preview & Submit PR" },
    { label: "Submission Successful" },
  ];

  const quillModules = useMemo(() => getQuillModules(Instance), []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    trigger,
  } = useFormValidation(submitPrSchema, formData);

  const controlStyles = (hasError) => ({
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: hasError ? "#dc3545 !important" : baseStyles.borderColor,
      boxShadow: hasError && state.isFocused ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important" : baseStyles.boxShadow,
      "&:hover": {
        borderColor: hasError ? "#dc3545 !important" : baseStyles.borderColor,
      },
    }),
    menu: (baseStyles) => ({
      ...baseStyles,
      zIndex: 99,
    }),
    menuPortal: (baseStyles) => ({
      ...baseStyles,
      zIndex: 99,
    }),
  });

  const getOptions = (imagesList) => {
    return imagesList.map((img) => ({
      value: img.galleryId,
      label: img.name,
    }));
  };

  const handleImageSelectionChange = (selectedOptions) => {
    if (selectedOptions && selectedOptions.length > MAX_FILE_COUNT) {
      showToast(
        `You can only select up to ${MAX_FILE_COUNT} supporting documents.`,
        "danger",
        "error",
      );
      return;
    }
    const selectedIds = (selectedOptions || []).map((option) => option.value);
    setSelectedImages(selectedIds);
    const imageIdsString = selectedIds.join("|");
    setFormData((prev) => ({ ...prev, image: imageIdsString }));
    setValue("image", imageIdsString);
    trigger("image");
    const selectedData = (selectedOptions || []).map((option) => {
      const imgData = imagesList.find((img) => img.galleryId === option.value);
      return imgData;
    });
    setSelectedImagesData(selectedData);
  };

  const handleCompanyIdChange = (e) => {
    const value = e.target.value;
    if (value === "ADD_NEW") {
      setCompanyId("ADD_NEW");
      setValue("company", "ADD_NEW");
      const emptyCompany = {
        name: "",
        contactPerson: "",
        address: "",
        mobile: "",
        email: "",
        website: "",
        state: "",
        country: "",
        city: "",
        isdCode: "",
      };
      setCompany(emptyCompany);
      Object.keys(emptyCompany).forEach((key) => {
        setValue(key, "");
      });
      return;
    }
    setCompanyId(value);
    setValue("company", value);
    if (value) {
      const selectedCompany = companyList.find(
        (company) => company.companyId === value,
      );

      if (selectedCompany) {
        let countryValue = selectedCompany.country || "";
        const countryMatch = countryList.find(
          (c) =>
            c.countryCode === countryValue ||
            c.countryName === countryValue ||
            c.countryId === countryValue,
        );
        if (countryMatch) {
          countryValue = countryMatch.countryCode;
        }

        const companyData = {
          name: selectedCompany.name || "",
          contactPerson: selectedCompany.contactPerson || "",
          address: selectedCompany.address || "",
          mobile: selectedCompany.mobile || "",
          email: selectedCompany.email || "",
          website: selectedCompany.website || "",
          state: selectedCompany.state || "",
          country: countryValue,
          city: selectedCompany.city || "",
          isdCode: selectedCompany.isdCode || "",
        };

        setCompany(companyData);

        Object.keys(companyData).forEach((key) => {
          setValue(key, companyData[key]);
        });

        clearErrors([
          "name",
          "contactPerson",
          "email",
          "mobile",
          "website",
          "address",
          "city",
          "state",
          "country",
        ]);
      }
    } else {
      // Reset fields if no company selected
      const emptyCompany = {
        name: "",
        contactPerson: "",
        address: "",
        mobile: "",
        email: "",
        website: "",
        state: "",
        country: "",
        city: "",
        isdCode: "",
      };
      setCompany(emptyCompany);

      Object.keys(emptyCompany).forEach((key) => {
        setValue(key, "");
      });
    }
  };

  // const handleCompanyIdChange = (e) => {
  //   const value = e.target.value;
  //   setCompanyId(value);
  //   if (value) {
  //     setCompany({
  //       name: "",
  //       contactPerson: "",
  //       address: "",
  //       mobile: "",
  //       email: "",
  //       website: "",
  //       state: "",
  //       country: "",
  //       city: "",
  //     });
  //     clearErrors([
  //       "companyName",
  //       "contactPerson",
  //       "email",
  //       "mobile",
  //       "website",
  //       "address",
  //       "city",
  //       "state",
  //       "country"
  //     ]);
  //   }
  // };

  const handleCompanyChange = (e) => {
    let { name, value } = e.target;
    if (name === "contactPerson") {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }
    setCompany({
      ...company,
      [name]: value,
    });
    setValue(name, value);
    trigger(name); // Explicitly trigger validation to show error messages
    if ((!!companyId && companyId !== "ADD_NEW") || isReadOnly) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (value) {
      clearErrors(name);
      if (companyId !== "ADD_NEW") {
        setCompanyId("");
        setValue("company", "");
      }
    }
  };

  const validateContentLimits = (data) => {
    const wordCount = data
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean).length;

    const imageCount = (data.match(/<img\b[^>]*>/g) || []).length;

    const linkCount = (data.match(/<a\b[^>]*>/g) || []).length;

    const limitErrors = {};

    // Check for word limit
    if (wordCount > WORD_LIMIT) {
      limitErrors.wordLimit = `Press Release body must not exceeded ${WORD_LIMIT}.`;
    }

    // Check for image limit
    if (imageCount > IMG_LIMIT) {
      limitErrors.imageLimit = `You can add a maximum of ${IMG_LIMIT} images.`;
    }

    // Check for link limit
    if (linkCount > LINK_LIMIT) {
      limitErrors.linkLimit = `You can add a maximum of ${LINK_LIMIT} links`;
    }

    return limitErrors;
  };

  const handleEditorChange = (content) => {
    const data = content;
    const validationErrors = validateContentLimits(data);
    setLimitErrors(validationErrors);
    setEditorData(data);
    setValue("editorData", data);
    setValue("description", data);
    // Clear form-level error if content becomes valid
    if (data && data.trim().length > 0) {
      clearErrors("editorData");
    }
    trigger("editorData");
  };

  const handleEditorResizeStart = (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = editorHeight || 300;
    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientY - startY;
      setEditorHeight(Math.max(300, startHeight + delta));
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const formatSize = (size) => {
    console.log(size, selectedImagesData);
    return size > 1024 * 1024
      ? `${(size / (1024 * 1024)).toFixed(2)} MB`
      : `${(size / 1024).toFixed(2)} KB`;
  };

  const handleShowSubmit = () => {
    setShowSubmit(true);
    setnavshow(2);
  };

  const handleNotShowSubmit = () => {
    setShowSubmit(false);
    setnavshow(1);
  };

  // const handleEditorChange = (event, editor) => {
  //   const data = editor.getData();

  //   // Validate the content and set errors
  //   const validationErrors = validateContentLimits(data);

  //   setLimitErrors(validationErrors);

  //   // Only update the editor data if no errors exist
  //   if (Object.keys(validationErrors).length === 0) {
  //     setEditorData(data);
  //   }
  // };

  // const handleFileChange = async (event) => {
  //   const token = localStorage.getItem("tokenId");
  //   const file = event.target.files[0];

  //   if (!file) {
  //     console.error("No file selected");
  //     return;
  //   }

  //   const formDataToSubmit = new FormData();
  //   formDataToSubmit.append("tokenId", token);
  //   formDataToSubmit.append("fileUpload", file);

  //   try {
  //     const uploadResponse = await axios.post(
  //       "https://pr.webandapi.com/site/upload/documents",
  //       formDataToSubmit,
  //       {
  //         headers: {
  //           "content-type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (uploadResponse?.data?.resCode === "200") {
  //       setFileName(file.name);
  //       setSelectedFilePath(uploadResponse.data.documentUrl);
  //       handleUpload(uploadResponse.data.documentUrl, file.name);
  //     } else {
  //       console.log("Upload image API failed:", uploadResponse.data);
  //     }
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //   }
  // };

  // const handleUpload = async (documentUrl, fileName) => {
  //   const token = localStorage.getItem("tokenId");

  //   try {
  //     const createGalleryResponse = await Instance.post(
  //       "/user/gallery/create",
  //       {
  //         tokenId: token,
  //         name: fileName,
  //         documentUrl: documentUrl,
  //         alternateText: "text",
  //       }
  //     );

  //     if (createGalleryResponse.data.resCode === "200") {
  //       showToast("Image Uploaded Successfully", "success", "success");
  //       const newImage = {
  //         galleryId: createGalleryResponse.data.id,
  //         name: fileName,
  //         documentUrl: documentUrl,
  //       };
  //       setImagesList((prevImagesList) => [...prevImagesList, newImage]);
  //       const newSelectedImages = [
  //         ...selectedImages,
  //         createGalleryResponse.data.id,
  //       ];
  //       setSelectedImages(newSelectedImages);
  //       setSelectedImagesData((prevSelectedImagesData) => [
  //         ...prevSelectedImagesData,
  //         newImage,
  //       ]);
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         image: newSelectedImages.join("|"),
  //       }));
  //       setFileName("");
  //       setSelectedFilePath("");
  //     } else {
  //       showToast("Failed to create gallery entry.", "danger", "error");
  //     }
  //   } catch (error) {
  //     console.error("Error creating gallery entry:", error);
  //     showToast("Error creating gallery entry.", "danger", "error");
  //   }
  // };

  const handleFileChange = async (event) => {
    const token = localStorage.getItem("tokenId");
    const files = Array.from(event.target.files);

    if (!files.length) {
      return;
    }

    const errors = [];
    const validFiles = [];

    if (selectedImages.length + files.length > MAX_FILE_COUNT) {
      // errors.push(`You can only upload up to ${MAX_FILE_COUNT} files.`);
      errors.push(`You can upload up to ${MAX_FILE_COUNT} supporting documents.`);
    }

    files.forEach((file) => {
      if (!ALLOWED_TYPES.includes(file.type)) {
        errors.push(
          // `${file.name}: Invalid file type (only JPG, JPEG, PDF allowed).`,
          `${file.name}: Invalid file format. Only JPG, PNG, and PDF are allowed.`,
        );
      } else if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        // errors.push(`${file.name}: File exceeds ${MAX_FILE_SIZE_MB}MB.`);
        errors.push(`${file.name}: File size must be ${MAX_FILE_SIZE_MB}MB or less. `);
      } else {
        validFiles.push(file);
      }
    });

    if (errors.length > 0) {
      // alert(errors.join("\n"));
      showToast(errors.join("\n"), "danger", "error");
      event.target.value = null;
      return;
    }

    for (const file of validFiles) {
      const formDataToSubmit = new FormData();
      // formDataToSubmit.append("tokenId", token);
      formDataToSubmit.append("fileUpload", file);

      try {
        const uploadResponse = await Instance.post(
          "site/upload/documents",
          formDataToSubmit,
          {
            headers: {
              "content-type": "multipart/form-data",
            },
          },
        );

        if (uploadResponse?.data?.resCode === "200") {
          handleUpload(uploadResponse.data.documentUrl, file.name, file.size);
        } else {
          // console.log("Upload image API failed:", uploadResponse.data);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }

    event.target.value = null; // Clear input
  };

  const handleUpload = async (documentUrl, fileName, fileSize) => {
    const token = localStorage.getItem("tokenId");

    try {
      const createGalleryResponse = await Instance.post(
        "user/gallery/create",
        {
          // tokenId: token,
          name: fileName,
          documentUrl: documentUrl,
          alternateText: "text",
          docType: "supportingDocument",
          size: fileSize
        }
      );

      if (createGalleryResponse.data.resCode === "200") {
        showToast("Image Uploaded Successfully", "success", "success");
        const newImage = {
          galleryId: createGalleryResponse.data.id,
          name: fileName,
          documentUrl: documentUrl,
          size: fileSize, // Store size in bytes
        };

        setImagesList((prev) => [...prev, newImage]);

        setSelectedImages((prevSelected) => {
          const updatedSelected = [
            ...prevSelected,
            createGalleryResponse.data.id,
          ];
          const imageIdsString = updatedSelected.join("|");

          setFormData((prevForm) => ({
            ...prevForm,
            image: imageIdsString,
          }));
          setValue("image", imageIdsString);

          return updatedSelected;
        });

        setSelectedImagesData((prevData) => [...prevData, newImage]);
      } else {
        showToast("Failed to create gallery entry.", "danger", "error");
      }
    } catch (error) {
      console.error("Error creating gallery entry:", error);
      showToast("Error creating gallery entry.", "danger", "error");
    }
  };

  const handleAddNewClick = (e) => {
    e.preventDefault();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  //   const getOptions = (imagesList) => {
  //   return imagesList.map(img => ({
  //     value: img.galleryId,
  //     label: img.name,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValue(name, value);

    // Clear the validation error if the value is now valid
    if (value) {
      clearErrors(name);
    }

    if (name === "image") {
      fetchImagesDetails(value);
    }
  };

  useEffect(() => {
    if (formData.image) {
      const selectedImage = imagesList.find(
        (img) => img.galleryId === formData.image,
      );
      if (selectedImage) {
        setImageInfo([selectedImage]);
      }
    }
  }, [formData.image]);

  const handleSubmitForm = async (formValues, status) => {
    // console.log("Submitting with status:", status);

    try {
      // const token = localStorage.getItem("tokenId");
      const {
        name,
        email,
        mobile,
        contactPerson,
        website,
        address,
        country,
        state,
        city,
        isdCode,
        editorData,
        packageId,
        ...otherFields
      } = formValues;

      const cleanedDescription = prepareDescriptionPayload(formValues.description || "");

      const finalPackageId = packageId || formData.packageId;
      const finalPackageMemberId = formData.packageMemberId ||
        packageList.find(p => String(p.packageId) === String(finalPackageId))?.packageMemberId || "";

      const payload = {
        // tokenId: token,
        ...otherFields,
        title: fixEncodingCorruption(formValues.title || ""),
        packageId: finalPackageId,
        packageMemberId: String(finalPackageMemberId),
        description: cleanedDescription,
        status,
        companyId: companyId === "ADD_NEW" ? "" : (companyId || ""),
        company: (companyId && companyId !== "ADD_NEW")
          ? ""
          : {
            name,
            email,
            mobile,
            contactPerson,
            website,
            address,
            country,
            state,
            city,
            isdCode,
          },
      };

      const response = await Instance.post(
        "/user/pressrelease/create",
        payload,
      );

      if (response.data.resCode === "200") {
        setError("");
        showToast("Details submitted successfully", "success", "success");
        setTimeout(() => {
          navigate("/customer/pr-manager");
        }, 2000);
      } else {
        setError("Failed to submit details");
        console.error("Error:", response.data.resMessage);
      }
    } catch (error) {
      setError("Failed to submit details");
      console.error("Error:", error);
    }
  };

  // const handleSubmitForm = async (formValues, status) => {
  //   console.log("Submitting with status:", status);

  //   debugger
  //   try {
  //     const token = localStorage.getItem("tokenId");

  //     const response = await Instance.post("/user/pressrelease/create", {
  //       tokenId: token,
  //       ...formValues,
  //       description: editorData,
  //       status: status,
  //       companyId: companyId ? companyId : null,
  //       company: company,
  //     });

  //     if (response.data.resCode === "200") {
  //       setError("");
  //       showToast("Details submitted successfully", "success", "success");
  //       setTimeout(() => {
  //         navigate("/customer/pr-manager");
  //       }, 2000);
  //     } else {
  //       setError("Failed to submit details");
  //       console.error("Error:", response.data.resMessage);
  //     }
  //   } catch (error) {
  //     setError("Failed to submit details");
  //     console.error("Error:", error);
  //   }
  // };

  // const handleSubmitForm = async (e, status) => {
  //   e.preventDefault();
  //   console.log("Submitting with status:", status);
  //   try {
  //     const token = localStorage.getItem("tokenId");
  //     const response = await Instance.post("/user/pressrelease/create", {
  //       tokenId: token,
  //       ...formData,
  //       description: editorData,
  //       status: status,
  //       companyId: companyId ? companyId : null,
  //       company: companyId ? null : company,
  //     });
  //     if (response.data.resCode === "200") {
  //       setError("");
  //       showToast("Details submitted successfully", "success", "success");
  //       setTimeout(() => {
  //         navigate("/user/pr-manager");
  //       }, 2000);
  //     } else {
  //       setError("Failed to submit details");
  //       console.error("Error:", response.data.resMessage);
  //     }
  //   } catch (error) {
  //     setError("Failed to submit details");
  //     console.error("Error:", error);
  //   }
  // };

  const fetchPackageList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/credit/list", {
      // tokenId: token,
      status: "ACTIVE",
      orderBy: "availablePR",
      orderByType: "DESC",
      availablePR: "1"
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          setPackageList(response.data.message);
          setError("");
        } else {
          setError("Failed to fetch package list");
          console.error(
            "Error fetching package list:",
            response.data.resMessage,
          );
        }
      })
      .catch((error) => {
        setError("Failed to fetch countries list");
        console.error("Error fetching countries list:", error);
      });
  };

  const fetchCountryList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/common/countryList", {
      // tokenId: token,
      status: "",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          const filteredCountries = response.data.message.filter(
            (country) => country.countryName.trim() !== "",
          );
          setCountryList(filteredCountries);
          setError("");
        } else {
          setError("Failed to fetch countries list");
          console.error(
            "Error fetching countries list:",
            response.data.resMessage,
          );
        }
      })
      .catch((error) => {
        setError("Failed to fetch countries list");
        console.error("Error fetching countries list:", error);
      });
  };

  const fetchCompanyList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/usercompany/getList", { /* tokenId: token */ })
      .then((response) => {
        if (response.data.resCode === "200") {
          setCompanyList(response.data.message);
          setError("");
        } else {
          setError("Failed to fetch company list");
          console.error(
            "Error fetching company list:",
            response.data.resMessage,
          );
        }
      })
      .catch((error) => {
        setError("Failed to fetch company list");
        console.error("Error fetching company list:", error);
      });
  };

  const fetchCategoryList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/category/getList", {
      // tokenId: token,
      status: "ACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          setCategoryList(response.data.message);
          setError("");
        } else {
          setError("Failed to fetch company list");
          console.error(
            "Error fetching company list:",
            response.data.resMessage,
          );
        }
      })
      .catch((error) => {
        setError("Failed to fetch company list");
        console.error("Error fetching company list:", error);
      });
  };

  const fetchImages = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/gallery/getList", {
      // tokenId: token,
      docType: "supportingDocument"
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          setImagesList(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      });
  };

  const fetchImagesDetails = (imageId) => {
    const token = localStorage.getItem("tokenId");
    Instance
      .post("user/gallery/details", {
        // tokenId: token,
        galleryId: imageId,
      })
      .then((response) => {
        if (response.data.resCode === "200") {
          setImageInfo([response.data.message]);
          // console.log("Image details id fetched successfully");
        } else {
          console.error(
            "Failed to fetch image details:",
            response.data.resMessage,
          );
          setImageInfo([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching image details:", error);
        setImageInfo([]);
      });
  };

  useEffect(() => {
    fetchPackageList();
    fetchCompanyList();
    fetchCountryList();
    fetchCategoryList();
    fetchImages();
  }, []);

  const copyURL = async (url) => {
    const textToCopy = typeof url === "string" ? url : String(url ?? "");
    if (!textToCopy) {
      showToast("Nothing to copy.", "error", "error");
      return;
    }

    try {
      const clipboard = typeof navigator !== "undefined" ? navigator.clipboard : undefined;
      if (clipboard && typeof clipboard.writeText === "function") {
        await clipboard.writeText(textToCopy);
        showToast("URL copied!", "success", "success");
        return;
      }

      const canUseDocument = typeof document !== "undefined";
      if (!canUseDocument) {
        showToast("Copy is not available in this environment.", "error", "error");
        return;
      }

      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, textArea.value.length);

      const copied = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (copied) {
        showToast("URL copied!", "success", "success");
      } else {
        showToast("Copy failed. Please copy manually.", "error", "error");
      }
    } catch (err) {
      showToast("Copy failed. Please copy manually.", "error", "error");
    }
  };

  const handleNavShow = () => {
    // console.log('limitErrors:', limitErrors);
    if (limitErrors && Object.keys(limitErrors).length > 0) {
      showToast(
        "Fix Press release body content errors before proceeding to next step.",
        "error",
        "error",
      );
      return;
    } else {
      setnavshow(1);
    }
  };

  const handleNotNavShow = () => {
    setnavshow(0);
  };

  // class MyUploadAdapter {
  //   constructor(loader) {
  //     this.loader = loader;
  //     this.url = "https://pr.webandapi.com/site/upload/documents"; // Your upload URL
  //   }

  //   upload() {
  //     return this.loader.file.then(
  //       (file) =>
  //         new Promise((resolve, reject) => {
  //           const data = new FormData();
  //           const token = localStorage.getItem("tokenId");
  //           data.append("fileUpload", file);
  //           data.append("tokenId", token);

  //           fetch(this.url, {
  //             method: "POST",
  //             body: data,
  //           })
  //             .then((response) => response.json())
  //             .then((result) => {
  //               if (result?.resCode === "200") {
  //                 // Resolve with the URL of the uploaded image
  //                 resolve({
  //                   default: result.documentUrl,
  //                 });
  //               } else {
  //                 reject("Upload failed");
  //               }
  //             })
  //             .catch((error) => {
  //               reject(error.message);
  //             });
  //         })
  //     );
  //   }

  //   abort() {
  //     // Reject the promise returned from upload() method if the upload was aborted.
  //   }
  // }

  // function MyCustomUploadAdapterPlugin(editor) {
  //   editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
  //     return new MyUploadAdapter(loader);
  //   };
  // }

  return (
    <>
      <div className="pr_preview_container">
        <div className="pr-stepper-container d-flex align-items-center justify-content-between">
          <Stepper currentStep={navshow} steps={steps} />
          <button
            className="back_btn_stepper"
            onClick={() => {
              if (navshow > 0) {
                setnavshow(navshow - 1);
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                onShowPRLayout ? onShowPRLayout() : navigate("/customer/pr-manager");
              }
            }}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Back
          </button>
        </div>
        <div className="pr-form-wrapper bg-white shadow rounded">
          <div className="pr_form_editor">
            <Form className="pr_form_text">
              <Form.Group className="mb-4">
                <Form.Label>Choose Package</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={packageList.map((list) => ({
                    value: String(list.packageMemberId),
                    packageId: String(list.packageId),
                    label: `${list.packageName} (Credit Left: ${Number(list.availablePR)} | Expiry: ${list.expiryDate
                      ? new Date(list.expiryDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                      })
                      : ''
                      })`,
                    isDisabled: Number(list.availablePR) === 0,
                  }))}
                  value={packageList
                    .map((list) => ({
                      value: String(list.packageMemberId),
                      packageId: String(list.packageId),
                      label: `${list.packageName} (Credit Left: ${Number(list.availablePR)} | Expiry: ${list.expiryDate
                        ? new Date(list.expiryDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })
                        : ''
                        })`,
                    }))
                    .find((opt) => opt.value === String(formData.packageMemberId) || (opt.packageId === String(formData.packageId) && !formData.packageMemberId)) || null}
                  onChange={(selectedOption) => {
                    const pmId = selectedOption ? selectedOption.value : "";
                    const pId = selectedOption ? selectedOption.packageId : "";
                    setFormData((prev) => ({
                      ...prev,
                      packageId: pId,
                      packageMemberId: pmId,
                    }));
                    setValue("packageId", pId);
                    setValue("packageMemberId", pmId);
                    trigger("packageId");
                  }}
                  styles={controlStyles(!!errors.packageId)}
                  placeholder="Select from dropdown"
                  isDisabled={isReadOnly}
                />
                {errors.packageId && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.packageId?.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Select Categories</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={categoryList.map((list) => ({
                    value: list.categoryId,
                    label: list.name,
                  }))}
                  value={categoryList
                    .map((list) => ({
                      value: list.categoryId,
                      label: list.name,
                    }))
                    .find((opt) => opt.value === formData.categoryId)}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.value : "";
                    setFormData((prev) => ({
                      ...prev,
                      categoryId: value,
                    }));
                    setValue("categoryId", value);
                    trigger("categoryId");
                  }}
                  styles={controlStyles(!!errors.categoryId)}
                  placeholder="Select from dropdown"
                  isDisabled={isReadOnly}
                />
                {errors.categoryId && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.categoryId?.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                {navshow !== 1 && (
                  <>
                    <Form.Label>Headline</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter text here"
                      className="submit_form_control"
                      {...register("title")}
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      readOnly={isReadOnly}
                      isInvalid={!!errors.title}
                      onBlur={() => trigger("title")}
                    />
                    {errors.title && (
                      <Form.Control.Feedback type="invalid">
                        {errors.title?.message}
                      </Form.Control.Feedback>
                    )}
                  </>
                )}
              </Form.Group>

              {navshow === 1 ? (
                <PRContentPreview
                  headline={formData.title}
                  bodyHtml={editorData}
                  quillFormats={quillFormats}
                  wordLimit={WORD_LIMIT}
                  imgLimit={IMG_LIMIT}
                  linkLimit={LINK_LIMIT}
                />
              ) : (
                <Form.Group className="mb-4">
                  <Form.Label>Press Release Body</Form.Label>
                  <div
                    className={`custom-ckeditor-wrapper ${editorHeight ? "is-manual-resize" : ""}`}
                    style={{ "--editor-h": editorHeight ? `${editorHeight}px` : "auto" }}
                  >
                    <ReactQuill
                      value={normalizeHtmlValue(editorData)}
                      onChange={handleEditorChange}
                      modules={quillModules}
                      formats={quillFormats}
                      bounds={".custom-ckeditor-wrapper"}
                      placeholder="Start typing your press release here..."
                      readOnly={isReadOnly}
                      theme="snow"
                    />
                    <div
                      className="editor-resize-handle"
                      onMouseDown={handleEditorResizeStart}
                      title={`Drag to resize editor`}
                    />

                    <div className="editor-footer mt-2">
                      {(() => {
                        const { wordCount, imageCount, linkCount } = getEditorMetrics(editorData);
                        return (
                          <>
                            <span>
                              Word Count: {wordCount}/{WORD_LIMIT}
                            </span>
                            <span>
                              Images: {imageCount}/{IMG_LIMIT}
                            </span>
                            <span>
                              Links: {linkCount}/{LINK_LIMIT}
                            </span>
                          </>
                        );
                      })()}
                    </div>

                  </div>
                  <div className="text-danger mt-2">
                    {limitErrors.wordLimit && (
                      <p className="mb-1">{limitErrors.wordLimit}</p>
                    )}
                    {limitErrors.imageLimit && (
                      <p className="mb-1">{limitErrors.imageLimit}</p>
                    )}
                    {limitErrors.linkLimit && (
                      <p className="mb-1">{limitErrors.linkLimit}</p>
                    )}
                    {errors.editorData?.message && <p>{errors.editorData.message}</p>}
                  </div>
                </Form.Group>
              )}

              <Form.Group className="mb-4">
                <Form.Label>Supporting Documents (Optional)</Form.Label>
                <button
                  className="pr_form_next_btn m-2"
                  onClick={handleAddNewClick}
                  disabled={isReadOnly}
                >
                  Add New
                </button>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  isMulti
                  options={getOptions(imagesList)}
                  onChange={handleImageSelectionChange}
                  value={getOptions(imagesList).filter((option) =>
                    selectedImages.includes(option.value),
                  )}
                  isDisabled={isReadOnly}
                  styles={controlStyles(!!errors.image)}
                />
                {errors.image && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.image?.message}
                  </Form.Control.Feedback>
                )}
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </Form.Group>
              {formData.image && (
                <div
                  className="mb-4"
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{ overflowX: "auto", width: "100%", outline: "none" }}
                    ref={scrollContainerRef}
                    tabIndex="0"
                  >
                    <Table
                      className="pr_support_docs_table mb-0"
                      style={{ tableLayout: "fixed", width: "100%", margin: 0 }}
                    >
                      <thead className="pr_tables_head" style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          <th style={{ width: "30%", padding: "12px 16px", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.04em", color: "#495057", borderBottom: "2px solid #dee2e6" }}>Document Name</th>
                          <th style={{ width: "35%", padding: "12px 16px", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.04em", color: "#495057", borderBottom: "2px solid #dee2e6" }}>Document URL</th>
                          <th style={{ width: "15%", padding: "12px 16px", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.04em", color: "#495057", borderBottom: "2px solid #dee2e6" }}>Size</th>
                          <th style={{ width: "20%", padding: "12px 16px", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.04em", color: "#495057", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Copy</th>
                        </tr>
                      </thead>
                      <tbody className="pr_tables_body">
                        {selectedImagesData.map((detail, index) => (
                          <tr key={index} style={{ borderBottom: "1px solid #dee2e6" }}>
                            <td style={{ padding: "12px 16px", wordBreak: "break-word", overflowWrap: "break-word", verticalAlign: "middle" }}>
                              {detail.name}
                            </td>
                            <td style={{ padding: "12px 16px", wordBreak: "break-word", overflowWrap: "break-word", verticalAlign: "middle", fontSize: "0.82rem", color: "#555" }}>
                              {detail.documentUrl || detail.imgUrl}
                            </td>
                            <td style={{ padding: "12px 16px", verticalAlign: "middle", whiteSpace: "nowrap" }}>
                              {detail.size ? formatSize(detail.size) : "-"}
                            </td>
                            <td style={{ padding: "12px 16px", verticalAlign: "middle", textAlign: "center" }}>
                              <button
                                className="pr_form_next_btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  copyURL(
                                    "https://pr.webandapi.com" + (detail.documentUrl || detail.imgUrl),
                                  );
                                }}
                              >
                                Copy
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}

              {/* <Form.Group className="mb-4">
            <Form.Label>Insert Image</Form.Label>
            <button
              className="pr_form_next_btn m-2"
              onClick={handleAddNewClick}
            >
              Add New
            </button>
            <Select
              isMulti
              options={getOptions(imagesList)}
              onChange={handleImageSelectionChange}
              value={getOptions(imagesList).filter((option) =>
                selectedImages.includes(option.value)
              )}
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Form.Group>
          {formData.image && (
            <Row className="mb-4 mx-1" style={{ overflow: "auto" }}>
              <Table striped bordered hover style={{ tableLayout: "fixed" }}>
                <thead>
                  <tr>
                    <th style={{ width: "25%" }}>Image Name</th>
                    <th style={{ width: "30%" }}>Image</th>
                    <th style={{ width: "25%" }}>URL</th>
                    <th style={{ width: "10%" }}>Size</th>
                    <th style={{ width: "10%" }}>Copy</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedImagesData.map((detail, index) => (
                    <tr key={index}>
                      <td style={{ wordWrap: "break-word" }}>{detail.name}</td>
                      <td style={{ wordWrap: "break-word" }}>
                        <img
                          src={detail.documentUrl}
                          alt={detail.name}
                          width={100}
                          style={{ wordBreak: "break-all" }}
                        />
                      </td>
                      <td style={{ wordWrap: "break-word" }}>
                        {detail.documentUrl}
                      </td>
                      <td style={{ wordWrap: "break-word" }}>{detail.size}</td>
                      <td>
                        <button
                          className="pr_form_next_btn"
                          onClick={(e) => {
                            e.preventDefault();
                            copyURL(
                              "https://pr.webandapi.com" + detail.documentUrl
                            );
                          }}
                        >
                          Copy
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          )} */}
              <Form.Group className="mb-4">
                <Form.Label>Select Sub-account</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={[
                    { value: "ADD_NEW", label: "Add new company" },
                    ...companyList.map((company) => ({
                      value: company.companyId,
                      label: company.name,
                    }))
                  ]}
                  value={[
                    { value: "ADD_NEW", label: "Add new company" },
                    ...companyList.map((company) => ({
                      value: company.companyId,
                      label: company.name,
                    }))
                  ].find((opt) => opt.value === companyId) || null}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.value : "";
                    handleCompanyIdChange({ target: { value } });
                  }}
                  placeholder="Select Company"
                  isDisabled={isReadOnly}
                  styles={controlStyles(false)}
                />
              </Form.Group>
              <h4 className="pr_or">OR</h4>
              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Company Name"
                    className="submit_form_control"
                    {...register("name")}
                    name="name"
                    value={company.name}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.name}
                  />
                  {errors.name && (
                    <Form.Control.Feedback type="invalid">
                      {errors.name.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Contact Person Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Person Name"
                    className="submit_form_control"
                    name="contactPerson"
                    {...register("contactPerson")}
                    value={company.contactPerson}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.contactPerson}
                  />
                  {errors.contactPerson && (
                    <Form.Control.Feedback type="invalid">
                      {errors.contactPerson.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>
              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    placeholder="Enter Email"
                    className="submit_form_control"
                    {...register("email")}
                    name="email"
                    value={company.email}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.email}
                  />
                  {errors.email && (
                    <Form.Control.Feedback type="invalid">
                      {errors.email.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Phone Number</Form.Label>
                  <div className="phone_input_wrapper">
                    <div className="isd_code_dropdown">
                      <Select
                        options={countryList.map((country) => ({
                          value: country.isdCode,
                          label: `${country.countryName} ${country.isdCode}`,
                          displayLabel: country.isdCode,
                          countryCode: country.countryCode,
                        }))}
                        formatOptionLabel={({ displayLabel, label, countryCode }) => (
                          <div className="d-flex align-items-center">
                            <img
                              src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                              alt=""
                              className="me-2"
                              style={{ width: "15px", height: "auto" }}
                            />
                            <span>{displayLabel || label.split(" ").pop()}</span>
                          </div>
                        )}
                        placeholder="+91"
                        isSearchable
                        classNamePrefix="react-isd-select"
                        menuPortalTarget={document.body}
                        value={
                          company.isdCode
                            ? {
                              value: company.isdCode,
                              label: `${countryList.find((c) => c.isdCode === company.isdCode)?.countryName || ""} ${company.isdCode}`,
                              displayLabel: company.isdCode,
                              countryCode: countryList.find((c) => c.isdCode === company.isdCode)?.countryCode || "in",
                            }
                            : null
                        }
                        onChange={(val) => {
                          const isdCode = val ? val.value : "";
                          setCompany({ ...company, isdCode });
                          setValue("isdCode", isdCode);
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: "8px 0 0 8px",
                            borderColor: "transparent",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "transparent",
                            },
                            minHeight: "48px",
                            borderRight: "none",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 99,
                            width: "150px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 99,
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#585edb"
                              : state.isFocused
                                ? "#f1f2fd"
                                : "transparent",
                            color: state.isSelected ? "white" : "#091e42",
                            "&:active": {
                              backgroundColor: "#585edb",
                            },
                          }),
                        }}
                        isDisabled={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                      />
                    </div>
                    <div className="phone_number_input">
                      <Form.Control
                        placeholder="Enter Phone Number"
                        className="submit_form_control"
                        {...register("mobile")}
                        name="mobile"
                        value={company.mobile}
                        onChange={handleCompanyChange}
                        readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                        isInvalid={!!errors.mobile}
                      />
                    </div>
                  </div>
                  {(errors.mobile || errors.isdCode) && (
                    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                      {errors.isdCode?.message || errors.mobile?.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>
              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Website</Form.Label>
                  <Form.Control
                    placeholder="Enter Website URL"
                    className="submit_form_control"
                    name="website"
                    {...register("website")}
                    value={company.website}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.website}
                  />
                  {errors.website && (
                    <Form.Control.Feedback type="invalid">
                      {errors.website.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Address</Form.Label>
                  <Form.Control
                    placeholder="Enter Address"
                    className="submit_form_control"
                    {...register("address")}
                    name="address"
                    value={company.address}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.address}
                  />
                  {errors.address && (
                    <Form.Control.Feedback type="invalid">
                      {errors.address.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs="3" className="custom_col_submit mb-4">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    placeholder="Enter City"
                    className="submit_form_control"
                    {...register("city")}
                    name="city"
                    value={company.city}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.city}
                  />
                  {errors.city && (
                    <Form.Control.Feedback type="invalid">
                      {errors.city.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col xs="3" className="custom_col_submit mb-4">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    placeholder="Enter State"
                    className="submit_form_control"
                    {...register("state")}
                    name="state"
                    value={company.state}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.state}
                  />
                  {errors.state && (
                    <Form.Control.Feedback type="invalid">
                      {errors.state.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col xs="6" className="custom_col_submit mb-4">
                  <Form.Label>Country</Form.Label>
                  <Select
                    className="submit_form_select"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={200}
                    menuPlacement="bottom"
                    options={countryList.map((country) => ({
                      value: country.countryCode,
                      label: country.countryName,
                      displayLabel: country.countryName,
                    }))}
                    formatOptionLabel={({ displayLabel, label, value }) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={`https://flagcdn.com/w20/${value.toLowerCase()}.png`}
                          alt=""
                          className="me-2"
                          style={{ width: "20px", height: "auto" }}
                        />
                        <span>{displayLabel || label.split(" ")[0]}</span>
                      </div>
                    )}
                    value={countryList
                      .map((country) => ({
                        value: country.countryCode,
                        label: `${country.countryName} ${country.isdCode}`,
                        displayLabel: country.countryName,
                      }))
                      .find((opt) => opt.value === company.country) || null}
                    onChange={(opt) => {
                      handleCompanyChange({ target: { name: "country", value: opt?.value || "" } });
                    }}
                    isDisabled={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isSearchable
                    placeholder="Select Country"
                    styles={controlStyles(!!errors.country)}
                  />
                  {errors.country && (
                    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                      {errors.country?.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                  {" "}
                  <Form.Group className="mb-4">
                    <Form.Label>Write note for editor ?</Form.Label>
                    <Form.Control
                      className="submit_form_select"
                      {...register("addNote")}
                      placeholder="Enter note for editor"
                      value={formData.addNote}
                      onChange={handleChange}
                      disabled={isReadOnly}
                      as="textarea"
                      rows={8}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="pr_form_btns">
            {navshow === 0 && (
              <>
                {formData.status !== "ACTION REQUIRED" && (
                  <button
                    className="pr_form_save_btn"
                    onClick={handleSubmit(
                      (formValues) => handleSubmitForm(formValues, "DRAFT"),
                      (errors) => {
                        showToast(
                          "Missing Required Fields! Please fill in all mandatory sections",
                          "error",
                          "error",
                        );
                      },
                    )}
                  >
                    Save as Draft
                  </button>
                )}
                <button
                  className="pr_form_next_btn"
                  onClick={handleSubmit(
                    (formValues) => {
                      setFormData((prev) => ({ ...prev, ...formValues }));
                      setnavshow(1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    },
                    (errors) => {
                      showToast(
                        "Missing Required Fields! Please fill in all mandatory sections.",
                        "error",
                        "error",
                      );
                    },
                  )}
                >
                  Next
                </button>
              </>
            )}
            {navshow === 1 && (
              <>
                {formData.status !== "ACTION REQUIRED" && (
                  <button
                    className="pr_form_save_btn"
                    onClick={() => handleSubmitForm(formData, "DRAFT")}
                  >
                    Save as Draft
                  </button>
                )}
                <button className="pr_form_save_btn" onClick={handleNotNavShow}>
                  Edit
                </button>
                {/* <button className="pr_edit_btn" onClick={handleNotNavShow}>
          <img
            className={"pr_edit_img"}
            src="/build/img/Edit.svg"
            alt="zex pr wire Logo"
            width={14}
            height={14}

          />
          Edit
        </button> */}
                {/* <div className={`pr_secondary_nav  ${navshow === 1 ? "" : "d-none"} `}> */}
                {/* <button className="pr_edit_btn" onClick={handleNotNavShow}>
          <img
            className={"pr_edit_img"}
            src="/build/img/Edit.svg"
            alt="zex pr wire Logo"
            width={14}
            height={14}

          />
          Edit
        </button>
        <img
          className={"pr_group_img"}
          src="/build/img/Group.png"
          alt="zex pr wire Logo"
          width={620}
          height={60}

        /> */}
                {/* </div> */}
                <button
                  className="pr_form_submit_btn"
                  onClick={handleShowSubmit}
                >
                  Submit PR
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showSubmit}
        onHide={handleNotShowSubmit}
        centered
        className="custom_modal"
      >
        <Modal.Body>
          <div className="submit_modal_img">
            <img
              className={"submit_done_img"}
              src="/build/Done.svg"
              alt="zex pr wire Logo"
              width={140}
              height={140}
            />
          </div>
          <div>
            <h5 className="submit_modal_head">Submit PR</h5>
            <p className="submit_modal_content">
              Are you sure you want to submit this Press Release?
            </p>
          </div>
          <div className="pr_modal_btn">
            <Button
              className="submit_cancel_btn"
              variant="secondary"
              onClick={handleNotShowSubmit}
            >
              Cancel
            </Button>
            <Button
              className="submit_save_btn"
              variant="primary"
              onClick={() => {
                const finalStatus = formData.addNote?.trim() ? "PENDING" : "PENDING";
                handleSubmitForm(formData, finalStatus);
              }}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

PRpreview.propTypes = {
  onShowPRLayout: PropTypes.func,
};
